import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Icon, UilCube } from "@iconscout/react-unicons";

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: "font-awesome" | "feather" | "unicons";
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  next?: boolean;
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
}

export const routes: RouteItems[] = [
  {
    label: "",
    icon: UilCube,

    pages: [
      {
        name: "CRM",
        path: "/dashboard",
        pathName: "crm",
        active: true,
        icon: "bar-chart-2",
        topNavIcon: "bar-chart-2",
      },
      {
        name: "analytics",
        path: "/analytics",
        pathName: "crm-analytics",
        active: true,
        icon: "pie-chart",
      },
      {
        name: "leads",
        path: "/leads",
        pathName: "crm-leads",
        active: true,
        icon: "file-text",
      },
      {
        name: "add-lead",
        path: "/add-lead",
        pathName: "crm-add-lead",
        active: true,
        icon: "server",
      },
      {
        name: "deals",
        path: "/deals",
        pathName: "crm-deals",
        active: true,
        icon: "trello",
      },
      {
        name: "deal-details",
        path: "/deal-details",
        pathName: "crm-deal-details",
        active: true,
        icon: "bookmark",
      },
      {
        name: "reports",
        path: "/reports",
        pathName: "crm-reports",
        active: true,
        icon: "clipboard",
      },
      {
        name: "collaborators",
        path: "/collaborators",
        pathName: "collaborators",
        active: true,
        icon: "bar-chart-2",
      },
      {
        name: "Price prediction model",
        path: "/price-prediction-model",
        pathName: "price-prediction-model",
        active: true,
        icon: "dollar-sign",
      },
      {
        name: "Smart CMA Workflow",
        path: "/smart-cma-workflow",
        pathName: "smart-cma-workflow",
        active: true,
        icon: "trending-up",
      },
      {
        name: "Chat",
        path: "/chat",
        pathName: "chat",
        active: true,
        icon: "app-chat",
      },
      {
        name: "Settings",
        icon: "tool",
        active: true,
        pages: [
          // {
          //   name: "Accounts",
          //   active: true,
          //   pages: [
          //     {
          //       name: "settings",
          //       path: "/email-settings",
          //       active: true,
          //     },
          //     {
          //       name: "emails",
          //       path: "/emails",
          //       active: true,
          //     },
          //     {
          //       name: "calendars",
          //       path: "/calendars",
          //       active: true,
          //     },
          //   ],
          // },
          {
            name: "Profile Settings",
            path: "/settings/profile-settings",
            active: true,
          },
          {
            name: "Company Settings",
            path: "/settings/onboarding",
            active: true,
          },
        ],
      },
    ],
  },
];
